import { render, staticRenderFns } from "./ribbon.vue?vue&type=template&id=1aa06e0a&scoped=true&"
import script from "./ribbon.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ribbon.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ribbon.vue?vue&type=style&index=0&id=1aa06e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa06e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/Desktop/business/EFM/02 RCP/code/rcp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa06e0a')) {
      api.createRecord('1aa06e0a', component.options)
    } else {
      api.reload('1aa06e0a', component.options)
    }
    module.hot.accept("./ribbon.vue?vue&type=template&id=1aa06e0a&scoped=true&", function () {
      api.rerender('1aa06e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/core/ribbon/ribbon.vue"
export default component.exports